import { Crown, Medal, Trophy, ShieldStar } from "@phosphor-icons/react";

const TIERS = {
  bronze: { label: "Bronze", icon: Medal, cls: "tier-bronze" },
  silver: { label: "Silver", icon: ShieldStar, cls: "tier-silver" },
  gold:   { label: "Gold",   icon: Trophy, cls: "tier-gold" },
  king:   { label: "King",   icon: Crown,  cls: "tier-king" },
};

export const LoyaltyBadge = ({ tier = "bronze", size = "md" }) => {
  const t = TIERS[tier] || TIERS.bronze;
  const Icon = t.icon;
  const sizeCls = size === "lg"
    ? "px-3.5 py-1.5 text-sm gap-2"
    : size === "sm"
    ? "px-2 py-0.5 text-[11px] gap-1"
    : "px-2.5 py-1 text-xs gap-1.5";
  return (
    <span className={`inline-flex items-center rounded-full font-medium ${t.cls} ${sizeCls}`} data-testid={`loyalty-badge-${tier}`}>
      <Icon weight="fill" size={size === "lg" ? 16 : 13} />
      {t.label}
    </span>
  );
};

export default LoyaltyBadge;
